import { useAuth0 } from '@auth0/auth0-react';
import { PropsWithChildren } from 'react';
import { PrimaryButton } from './Buttons';
import { useUIState } from '../../context/uiState';
import { useNavigate } from 'react-router-dom';
import { getUserInfoFromLocalStorage, saveReturnToUrl } from '@utils/LocalStorageUtils';
import { getLastUserLogin } from '../../types/auth';

export const LoginButton = () => {
  const { loginWithRedirect, loginWithPopup, handleRedirectCallback } = useAuth0();
  const { state } = useUIState();
  const { loadedInChromeExtension } = state;

  const handleLogin = async () => {
    // Save the current URL so we can redirect back after login
    saveReturnToUrl();

    // First check for current user info, then fall back to last logged out user
    const userInfo = getUserInfoFromLocalStorage();
    const lastUserLogin = getLastUserLogin(); // Use validated helper
    const previousEmail = userInfo?.email || lastUserLogin.email;

    const authorizationParams = previousEmail ? { login_hint: previousEmail } : undefined;

    if (loadedInChromeExtension) {
      await loginWithPopup({
        authorizationParams,
      });
      window.location.href = '/callback'; // Redirect to your callback route
    } else {
      await loginWithRedirect({
        authorizationParams,
      });
    }
  };

  return <PrimaryButton handleClick={handleLogin}>Login</PrimaryButton>;
};
